import { ddayjs } from '@dt/fe-utils'
import { m2n, getDaysBetween } from '@utils'
import { find } from '@dt/fe-utils/dist/lodash'

export interface IRedeemInfoType {
  name: string;
  type: number;
  status: number;
  cdTime: string;
  saleStart: string;
  saleEnd: string;
  expired: number;
  saleCnt: number;
  stockCnt: number;
  allSaleCnt: number;
  saleRate: number;
  remainCnt: number;
  saleCircle: string;
}
class RedeemSDK {
  constructor () {

  }
  /**
   * 售卖类型
   * 无限制售卖: 0
   * 总量售卖: 1
   * 周期售卖: 2
   */
  /**
   * 售卖状态
   * 待售: 0
   * 在售: 1
   * 售罄: 2
   * 本轮结束(可售卖): 3
   * 结束(不可售卖): 4
   * 全时段在售: 5
   * 没有售卖时段: 6
   * 未上架: 7
   */
  private info: any = {}
  private type: number = 0
  private status: number = 0
  // 倒计时的时间
  private cdTime: string = ''
  // 开售区间
  private saleStart: string = ''
  private saleEnd: string = ''
  // 过期天数
  private expired: number = -1
  // 本期已售数量
  private saleCnt: number = -1
  // 库存数量
  private stockCnt: number = -1
  // 累计已售
  private allSaleCnt: number = 0
  // 剩余数量
  private remainCnt: number = -1
  // 售卖周期
  private saleCircle: string = ''

  private initData () {
    this.info = {}
    this.type = 0
    this.status = 0
    this.cdTime = ''
    this.saleStart = ''
    this.saleEnd = ''
    this.expired = -1
    this.saleCnt = -1
    this.stockCnt = -1
    this.allSaleCnt = 0
    this.remainCnt = -1
  }

  private getMonthDays (year: number, month: number) {
    let d = new Date(year, month, 0)
    return d.getDate()
  }

  private getTime () {
    if (this.info.timeRangeType === 'month') {
      const obj: any = {
        status: 0, // 0 不可售 1 可售
        day: -1,
        startTime: '',
        endTime: ''
      }
      const date: number = ddayjs('brand').date()
      const findDate: any = find(this.info.timeRanges, (item: any) => item.monthDay === date)
      const currYear: number = ddayjs('brand').year()
      const currMon: number = ddayjs('brand').month() + 1
      const currMonthDay: number = this.getMonthDays(currYear, currMon)
      const checkOther = () => {
        obj.status = 0
        obj.startTime = '00:00'
        obj.endTime = '24:00'
        for (let i = 0; i < this.info.timeRanges.length; i++) {
          const item: any = this.info.timeRanges[i]
          if (item.monthDay > date) {
            obj.day = item.monthDay - date
            break
          }
        }
        if (obj.day === -1) {
          for (let i = 0; i < this.info.timeRanges.length; i++) {
            const item: any = this.info.timeRanges[i]
            if (item.monthDay < date) {
              obj.day = currMonthDay - date + item.monthDay + 1
              break
            }
          }
        }
      }
      if (findDate) {
        obj.status = 1
        obj.day = 0
        obj.startTime = '00:00'
        obj.endTime = '24:00'
        return obj
      } else {
        checkOther()
      }
      return obj
    } else {
      const week: number = ddayjs('brand').day()
      const weekIndex: number = week === 0 ? 6 : week - 1
      const weekObj: any = this.info.timeRanges[weekIndex]
      const obj: any = {
        status: 0, // 0 不可售 1 可售
        day: -1,
        startTime: '',
        endTime: ''
      }
      const checkOther = () => {
        obj.status = 0
        for (let i = 0; i < this.info.timeRanges.length; i++) {
          const item: any = this.info.timeRanges[i]
          if (i > weekIndex && item.isOpen) {
            obj.day = i - weekIndex
            obj.startTime = item.ranges[0].startTime
            obj.endTime = item.ranges[0].endTime
            break
          }
        }
        if (obj.day === -1) {
          for (let i = 0; i < this.info.timeRanges.length; i++) {
            const item: any = this.info.timeRanges[i]
            if (i < weekIndex && item.isOpen) {
              obj.day = 6 - weekIndex + i + 1
              obj.startTime = item.ranges[0].startTime
              obj.endTime = item.ranges[0].endTime
              break
            }
          }
        }
      }
      if (weekObj && weekObj.isOpen) {
        const currentTime: string = ddayjs('brand').format('HH:mm')
        for (let i = 0; i < weekObj.ranges.length; i++) {
          const rangeItem: any = weekObj.ranges[i]
          const currentTimeVal = m2n(currentTime)
          const satrtTimeVal = m2n(rangeItem.startTime)
          const endTimeVal = m2n(rangeItem.endTime)
          if (currentTimeVal < satrtTimeVal) {
            obj.day = 0
            obj.status = 0
            obj.startTime = rangeItem.startTime
            obj.endTime = rangeItem.endTime
            break
          }
          if (currentTimeVal >= satrtTimeVal && currentTimeVal < endTimeVal) {
            obj.day = 0
            obj.status = 1
            obj.startTime = rangeItem.startTime
            obj.endTime = rangeItem.endTime
            break
          }
        }
        if (obj.day === -1) {
          checkOther()
        }
      } else {
        checkOther()
      }
      return obj
    }
  }

  private checkInfo = () => {
    const timeObj = this.getTime()
    if (timeObj.status === 0 && timeObj.day === -1) {
      this.status = 6
    } else if (timeObj.status === 0 && timeObj.day > 0) {
      if (this.expired !== -1 && this.expired <= timeObj.day) {
        this.status = 4
      } else {
        this.status = 3
      }
      const cdDate: string = ddayjs('brand').add(timeObj.day, 'days').format('YYYY-MM-DD')
      const cdTime: string = `${cdDate} ${timeObj.status === 0 ? timeObj.startTime : timeObj.endTime}`
      this.cdTime = cdTime
      this.saleStart = `${cdDate} ${timeObj.startTime}`
      this.saleEnd = `${cdDate} ${timeObj.endTime}`
    } else {
      this.status = timeObj.status
      const cdDate: string = ddayjs('brand').add(timeObj.day, 'days').format('YYYY-MM-DD')
      const cdTime: string = `${cdDate} ${timeObj.status === 0 ? timeObj.startTime : timeObj.endTime}`
      this.cdTime = cdTime
      this.saleStart = `${cdDate} ${timeObj.startTime}`
      this.saleEnd = `${cdDate} ${timeObj.endTime}`
    }
  }

  public getInfo = (info: any): IRedeemInfoType => {
    this.initData()
    this.info = info
    if (info.endTime) {
      const startDate: any = ddayjs('brand').format('YYYY-MM-DD')
      const endDate: any = ddayjs(info.endTime, 'brand').format('YYYY-MM-DD')
      this.expired = getDaysBetween(startDate, endDate)
    }
    if (info.saleType) {
      if (info.saleType === 'total') {
        this.type = 1
        if (info.productPeriodSaleCnt === 0) {
          this.status = 2
        } else {
          if (info.isAllTime) {
            this.status = 5
          } else {
            this.checkInfo()
          }
        }
      } else {
        this.type = 2
        if (info.productPeriodSaleCnt === 0) {
          if (info.saleType === 'dayCycle') {
            const cdTime: string = `${ddayjs('brand').add(1, 'days').format('YYYY-MM-DD')} 00:00`
            this.cdTime = cdTime
            if (this.expired !== -1 && this.expired <= 1) {
              this.status = 4
            } else {
              this.status = 2
            }
          } else if (info.saleType === 'weekCycle') {
            const weekDay: number = ddayjs('brand').day()
            const addDay: number = weekDay === 0 ? 1 : 8 - weekDay
            const cdTime: string = `${ddayjs('brand').add(addDay, 'days').format('YYYY-MM-DD')} 00:00`
            this.cdTime = cdTime
            if (this.expired !== -1 && this.expired <= addDay) {
              this.status = 4
            } else {
              this.status = 2
            }
          } else if (info.saleType === 'monthCycle') {
            let month: number = ddayjs('brand').month() + 1
            let year: number = ddayjs('brand').year()
            if (month === 12) {
              month = 1
              year = year + 1
            } else {
              month += 1
            }
            const cdTime: string = `${year}-${month < 10 ? '0' + month : month}-01 00:00`
            this.cdTime = cdTime
            const startDate: any = ddayjs('brand').format('YYYY-MM-DD')
            const endDate: any = `${year}-${month < 10 ? '0' + month : month}-01`
            const betweenDay: number = getDaysBetween(startDate, endDate)
            if (this.expired !== -1 && this.expired <= betweenDay - 1) {
              this.status = 4
            } else {
              this.status = 2
            }
          }
        } else {
          if (info.isAllTime) {
            this.status = 5
          } else {
            this.checkInfo()
          }
        }
      }
    } else {
      this.type = 0
      if (info.isAllTime) {
        this.status = 5
      } else {
        this.checkInfo()
      }
    }
    if (info.saleType) {
      this.saleCnt = info.productSaleCnt - info.productPeriodSaleCnt
      this.stockCnt = info.productSaleCnt
      this.remainCnt = info.productPeriodSaleCnt
      switch (info.saleType) {
        case 'dayCycle':
          this.saleCircle = 'day'
          break
        case 'weekCycle':
          this.saleCircle = 'week'
          break
        case 'monthCycle':
          this.saleCircle = 'month'
          break
        default:
          break
      }
    }
    this.allSaleCnt = info.allSaleCnt
    if (info.endTime && info.startTime) {
      if (ddayjs().valueOf() < ddayjs(info.startTime).valueOf()) {
        this.status = 7
      }
    }
    const resultObj: IRedeemInfoType = {
      name: info.productName,
      type: this.type,
      status: this.status,
      cdTime: this.cdTime,
      saleStart: this.saleStart,
      saleEnd: this.saleEnd,
      expired: this.expired,
      saleCnt: this.saleCnt,
      stockCnt: this.stockCnt,
      allSaleCnt: this.allSaleCnt,
      saleRate: Math.floor((this.saleCnt / this.stockCnt) * 100),
      remainCnt: this.remainCnt,
      saleCircle: this.saleCircle
    }
    return resultObj
  }
}

export default new RedeemSDK()
